import { createTheme } from '@mui/material/styles';
import { blue as primary } from '@mui/material/colors';

// import CircularStdBold from '../../fonts/CircularStd/CircularStd-Bold.otf';
// import CircularStdBoldItalic from '../../fonts/CircularStd/CircularStd-BoldItalic.otf';
// import CircularStdBook from '../../fonts/CircularStd/CircularStd-Book.otf';
// import CircularStdBookItalic from '../../fonts/CircularStd/CircularStd-BookItalic.otf';
// import CircularStdLightItalic from '../../fonts/CircularStd/CircularStd-Light Italic.otf';
// import CircularStdLight from '../../fonts/CircularStd/CircularStd-Light.otf';
// import CircularStdMedium from '../../fonts/CircularStd/CircularStd-Medium.otf';
// import CircularStdMediumItalic from '../../fonts/CircularStd/CircularStd-MediumItalic.otf';
// import CircularStdBlackItalic from '../../fonts/CircularStd/CircularStd-BlackItalic.otf';
// import CircularStdBlack from '../../fonts/CircularStd/CircularStd-Black.otf';
// import LatoRegularBook from '../../fonts/Lato/Lato-Regular.ttf';
// import RobotoCondensedRegular from '../../fonts/Roboto_Condensed/RobotoCondensed-Regular.ttf';

const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: primary[500],
      dark: '#005',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },

   overrides: {
    MuiCheckbox: {
      colorSecondary: {
        color: '#f44336',
        '&$checked': {
          color: '#f44336',
        },
      },
    },
  },

  // Mobile (Smartphone) max-width: 480px
  // Low Resolution Tablets and ipads max-width: 767px
  // Tablets Ipads portrait mode max-width:1024px
  // Desktops max-width:1280px
  // Huge size (Larger screen) max-width: 1281px and greater

  breakpoints: {
    values: {
      xs: 0,
      sm: 767,
      md: 1024,
      lg: 1280,
      xl: 1636,
    },
  },

  typography: {
    allVariants: {
      fontFamily: ['Roboto Condensed'],
    },

    typography: {
      fontFamily: [
        // '"CircularStd"',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Roboto Condensed"',
      ].join(','),
      // fontFace: `
      //      @font-face {
      //         font-family: 'CircularStd';
      //         font-style: normal;
      //         font-weight: 300;
      //         src: local(''),
      //               url(${CircularStdLight}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: italic;
      //         font-weight: 300;
      //         src: local(''),
      //               url(${CircularStdLightItalic}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: normal;
      //         font-weight: 400;
      //         src: local(''),
      //               url(${CircularStdBook}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: italic;
      //         font-weight: 400;
      //         src: local(''),
      //               url(${CircularStdBookItalic}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: normal;
      //         font-weight: 500;
      //         src: local(''),
      //               url(${CircularStdMedium}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: italic;
      //         font-weight: 500;
      //         src: local(''),
      //               url(${CircularStdMediumItalic}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: normal;
      //         font-weight: 600;
      //         src: local(''),
      //               url(${CircularStdBold}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: italic;
      //         font-weight: 600;
      //         src: local(''),
      //               url(${CircularStdBoldItalic}) format('opentype');
      //       }
      //        @font-face {
      //         font-family: 'CircularStd';
      //         font-style: normal;
      //         font-weight: 700;
      //         src: local(''),
      //               url(${CircularStdBlack}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'CircularStd';
      //         font-style: italic;
      //         font-weight: 700;
      //         src: local(''),
      //               url(${CircularStdBlackItalic}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'LatoRegular';
      //         src: local(''), url(${LatoRegularBook}) format('opentype');
      //       }
      //       @font-face {
      //         font-family: 'Roboto Condensed';
      //         src: local(''), url(${RobotoCondensedRegular}) format('opentype');
      //       }
      //       `,
    },
  },
});

export default theme;
